// extracted by mini-css-extract-plugin
module.exports = {"duration":"CountDown_duration__Gyku2"};